class Seniority {
  getDisplayText (answers) {
    if (answers.length == 1) {
      return this.singleSeniority(answers[0])
    } else {
      let mapped_answers = answers.map(this.getValueByQuestionText, this)
      return this.multipleSeniority(mapped_answers)
    }
  }

  getValueByQuestionText (question_text) {
    let dictionaryHash = this.getDictionaryHash()
    for (let obj in dictionaryHash) {
      if (dictionaryHash[obj].question_text == question_text) {
        return dictionaryHash[obj].value
      }
    }
  }

  multipleSeniority (answers) {
    if (answers.length == 0) {
      return { years: '0+', surfix: 'שנות ותק' }
    }
    let min = this.ignoreNegative(Math.min(...answers))
    let max = this.ignoreNegative(Math.max(...answers))
    if (max >= 5) {
      return { years: min + '+', surfix: ' שנ׳ ותק' }
    } else {
      return { years: max + ' - ' + min, surfix: ' שנ׳ ותק' }
    }
  }

  ignoreNegative (num) {
    return Math.max(0, num)
  }

  singleSeniority (answer) {
    return { years: answer, surfix: ' שנ׳ ותק' }
  }

  getDictionaryHash () {
    return [
      {
        'question_text': '0',
        'text': '0',
        'value': 0
      },
      {
        'question_text': '1',
        'text': '1',
        value: 1
      },
      {
        'question_text': '2',
        'text': '2',
        value: 2
      },
      {
        'question_text': '3',
        'text': '3',
        value: 3
      },
      {
        'question_text': '4',
        'text': '4',
        value: 4
      },
      {
        'question_text': '5',
        'text': '5',
        value: 5
      },
      {
        'question_text': '5+',
        'text': '5+',
        value: 5
      },
      {
        'question_text': '6',
        'text': '6',
        value: 6
      },
      {
        'question_text': '7',
        'text': '7',
        value: 7
      },
      {
        'question_text': '8',
        'text': '8',
        value: 8
      },
      {
        'question_text': '9',
        'text': '9',
        value: 9
      },
      {
        'question_text': '10',
        'text': '10',
        value: 10
      },
      {
        'question_text': '11',
        'text': '11',
        value: 11
      },
      {
        'question_text': '12',
        'text': '12',
        value: 12
      },
      {
        'question_text': '13',
        'text': '13',
        value: 13
      },
      {
        'question_text': '14',
        'text': '14',
        value: 14
      },
      {
        'question_text': '15',
        'text': '15',
        value: 15
      },
      {
        'question_text': '16',
        'text': '16',
        value: 16
      },
      {
        'question_text': '17',
        'text': '17',
        value: 17
      },
      {
        'question_text': '18',
        'text': '18',
        value: 18
      },
      {
        'question_text': '19',
        'text': '19',
        value: 19
      },
      {
        'question_text': '20',
        'text': '20',
        value: 20
      },
      {
        'question_text': '21',
        'text': '21',
        value: 21
      },
      {
        'question_text': '22',
        'text': '22',
        value: 22
      },
      {
        'question_text': '23',
        'text': '23',
        value: 23
      },
      {
        'question_text': '24',
        'text': '24',
        value: 24
      },
      {
        'question_text': '25',
        'text': '25',
        value: 25
      },
      {
        'question_text': '26',
        'text': '26',
        value: 26
      },
      {
        'question_text': '27',
        'text': '27',
        value: 27
      },
      {
        'question_text': '28',
        'text': '28',
        value: 28
      },
      {
        'question_text': '29',
        'text': '29',
        value: 29
      },
      {
        'question_text': '30+',
        'text': '30+',
        value: 30
      }
    ]
  }
}

export default Seniority
